// auto-generated by {apiBaseUrl}/tools/typescriptmodels
export enum TextSearchPatternOrItemListType {
	TextSearchPattern = 1,
	ListSingleItem = 2,
	ListMultipleOrs = 3,
	ListMultipleAnds = 4,
}